import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { BaseButton } from '..';

const GraphicButton: React.FC<GraphicButtonProps> = ({
    icon: Icon,
    children,
    className,
    ...domProps
}) => {
    const classes = useStyles();

    return (
        <BaseButton className={`${classes.graphicButton} ${className}`} {...domProps}>
            <div className={classes.graphicButtonIcon}>
                <Icon />
            </div>
            <span className={classes.graphicsButtonText}>{children}</span>
        </BaseButton>
    );
};

const useStyles = makeStyles(
    theme => ({
        graphicButton: {
            width: 72,
            '&:hover:enabled > div': {
                backgroundColor: `${theme.palette.greys[700]}12`,
            },
            '&:disabled': {
                cursor: 'default',
                opacity: 0.2,
            },
        },
        graphicButtonIcon: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: theme.palette.greys[100],
            fontSize: '4.2rem',
            width: 72,
            height: 72,
            border: `1px solid ${theme.palette.greys[300]}`,
            borderRadius: 12,
            transition: `all 300ms ease-in-out`,
        },
        graphicsButtonText: {
            marginTop: 4,
            display: '-webkit-box',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal' as const,
            color: theme.palette.greys[700],
            textAlign: 'center',
            ...theme.typography.t71,
        },
    }),
    { classNamePrefix: 'graphic-button' }
);

export interface GraphicButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon: React.FC;
}

export default GraphicButton;
